import { fork } from 'redux-saga/effects';
// Sagas
import ingresar from './ingresar';
import validar from './validar';
import desafios from './desafios';
import sesion from './sesion';
import revoke from './remokeToken';
import generarCP from './generarDesafioCP';
import validarCP from './validarDesafioCP';
import generarTcco from './generarDesafioTcoo';
import validarTcoo from './validarDesafioTcoo';
import timer from './timer';
import informar from './informar';
import transaccion from './transaccion';

// General forking sagas.
export default function* rootSaga() {
  yield fork(ingresar);
  yield fork(validar);
  yield fork(desafios);
  yield fork(sesion);
  yield fork(revoke);
  yield fork(transaccion);
  yield fork(generarCP);
  yield fork(validarCP);
  yield fork(generarTcco);
  yield fork(validarTcoo);
  yield fork(informar);
  yield fork(timer);
}
